export default "__VITE_ASSET__5XpDkRG0__"